import { render, staticRenderFns } from "./LinkResult.vue?vue&type=template&id=3f528bb8&scoped=true&"
import script from "./LinkResult.vue?vue&type=script&lang=js&"
export * from "./LinkResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f528bb8",
  null
  
)

export default component.exports